import { MenuList } from '@mui/material'
import { Dialog } from '@tunasong/ui-lib'
import { type FC } from 'react'
import { ToolsMenuItems } from './tools-menu-items.js'

export interface ToolsDialogProps {
  open: boolean
  onClose: () => void
}

export const ToolsDialog: FC<ToolsDialogProps> = props => {
  const {} = props
  return (
    <Dialog fullScreen fullWidth title="Tools" {...props}>
      <MenuList>
        <ToolsMenuItems onClose={props.onClose} />
      </MenuList>
    </Dialog>
  )
}

export default ToolsDialog
